import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { reviewsListingApi } from '@apis/seller-center/reviews.js';
import { Toast } from '@common-web/index.js';
import { getErrorString } from '@utils/utils.js';

const initialState = {
  reviews: [],
  statuses: [],
  pagination: null,
  success: false,
  loading: false,
  aggregations: null,
};

export const fetchReviewsListing = createAsyncThunk('reviews/listing', async (params = '') => {
  try {
    const reviews = await reviewsListingApi(params);
    return reviews;
  } catch (err) {
    Toast.error(getErrorString(err));
  }
});

const ReviewsSlice = createSlice({
  name: 'reviews',
  initialState,
  reducers: {
    updateReview: (state, action) => {
      const review = action.payload;
      const index = state.reviews.findIndex((item) => item.id === review.id);
      if (index !== -1) {
        state.reviews[index] = {
          ...state.reviews[index],
          comment: review.comment,
        };
      }
    },
    setReviews: (state, action) => {
      state.reviews = action.payload?.reviews;
      state.pagination = action?.payload?.pagination ?? state?.pagination;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(fetchReviewsListing.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchReviewsListing.fulfilled, (state, action) => {
        state.reviews =
          action?.payload?.pagination.current_page > 1
            ? [...state.reviews, ...action?.payload?.reviews]
            : action?.payload?.reviews;
        state.pagination = action?.payload?.pagination;
        state.aggregations = action?.payload?.aggregations;
        state.loading = false;
      });
  },
});

export const { updateReview, setReviews } = ReviewsSlice.actions;
export default ReviewsSlice.reducer;
